import { CurrentUserResource } from '../../Types';

export interface Props {
  children: (resource: CurrentUserResource) => React.ReactNode;
}

export const errorName = 'WithCurrentUserError';
export const errorMessage =
  'Improper use of WithCurrentUser outside of SetCurrentUser context provider!';
